import { BaseApiService } from '~/services/base-api.service';
import { DiscountTypes } from '~/types/model.types';
import { IGenericConfig } from '../types/client-exprience.types';
import type { GlobalCXContextValue } from '~/components/ClientExperience/providers/global-context/global-cx.context';

interface IPaymentDetailsResponse {
    pay_data: {
        final_price_after_discount: number;
        proposal: {
            price: number;
            name: string;
            discount: number;
            discount_type: DiscountTypes;
        };
        client: {
            client_email: string;
            client_full_name: string;
        };
        vendor: {
            name: string;
            company_name: string;
            image: string;
            icon: string;
            company_brand_color: string;
            company_text_color: string;
        };
        style_container: {
            form_component_style: {
                _id: string;
                font_type: string;
                font_family: string;
                font_url: string;
                font_color: string;
                // TODO: type all these correctly
                font_size: string;
                font_weight: 'normal' | 'bold';
                border_color: string;
                background_color: string;
            };
            button_component_style: {
                _id: string;
                font_type: string;
                font_family: string;
                font_url: string;
                font_color: string;
                font_size: string;
                font_weight: string;
                border_color: string;
                background_color: string;
            };
            global_style: {
                _id: string;
                font_type: string;
                font_family: string;
                font_url: string;
                font_color: string;
                font_size: string;
                font_weight: string;
                border_color: string;
                background_color: string;
            };
        };
    };
    vendor: {
        name: string;
        company_name: string;
        image: string;
        icon: string;
        company_brand_color: string;
        company_text_color: string;
    };
    ok: boolean;
    invalid_reason: string;
    create_new_url: string;
}

export interface IPaymentDetailsPayResponse {
    ok: boolean;
    invoice_number: string;
    charge_date: string;
    gift_card_code: string;
    invalid_reason?: string;
    create_new_url?: string;
}

// TODO: move to server.types.ts (didn't do it because that required changing some builder code)
export interface IErrorMessage {
    error: string;
}

export class GiftCardCXApiService extends BaseApiService {
    globalContext: GlobalCXContextValue = null;

    constructor(globalContext: GlobalCXContextValue) {
        super(globalContext);
        this.globalContext = globalContext;
    }

    protected getBaseUrl() {
        const { clientPortalConfigStore } = this.globalContext;
        return clientPortalConfigStore.apiBaseUrl;
    }

    async fetchPlacementGenericConfigNonProd(): Promise<IGenericConfig> {
        const {
            clientPortalConfigStore: { isPreview }
        } = this.globalContext;

        if (isPreview) {
            return null;
        }

        return this.apiRequest<IGenericConfig>({
            url: '/placement_generic_config.js',
            isJsonp: true
        });
    }

    async fetchPaymentData(hbToken: string) {
        const {
            clientPortalConfigStore: { isPreview }
        } = this.globalContext;

        if (isPreview) {
            return null;
        }

        return this.apiRequest<IPaymentDetailsResponse>({
            url: `/api/v2/instant-pay/load?hb_token=${hbToken}`
        });
    }

    async pay(
        forterToken: any,
        hbToken: string,
        card: any
    ): Promise<IPaymentDetailsPayResponse | IErrorMessage> {
        const {
            clientPortalConfigStore: { isPreview }
        } = this.globalContext;

        if (isPreview) {
            return new Promise<IPaymentDetailsPayResponse>(resolve =>
                resolve({
                    ok: true,
                    invoice_number: '12345',
                    gift_card_code: 'ABCD',
                    charge_date: new Date().toDateString()
                })
            );
        }

        const payload = {
            stripe: card,
            hb_token: hbToken,
            forter_token: forterToken
        };

        try {
            return await this.apiRequest<IPaymentDetailsPayResponse>({
                url: '/api/v2/instant-pay/pay',
                method: 'POST',
                data: payload
            });
        } catch (e) {
            return {
                error: e.response.data.error_message
            };
        }
    }
}
